// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__AALFi","info":"Note_info__1faRU","note":"Note_note__3znhA","actions":"Note_actions__qEc0S"};